import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.246.214A.73.73 0 0 0 .214 1.246L2.967 4 .214 6.754a.73.73 0 1 0 1.032 1.032L4 5.033l2.754 2.753a.73.73 0 1 0 1.032-1.032L5.033 4l2.753-2.754A.73.73 0 1 0 6.754.214L4 2.967 1.246.214Z" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }